const ALLOWED_DOMAINS = ['7edge.com'];
const RESTRICTED_ENVIRONMENTS = ['dev', 'qa', 'pre-prod'];

export const isDomainRestricted = () => {
    const currentStage = process.env.REACT_APP_STAGE;
    const isRestricted = RESTRICTED_ENVIRONMENTS.includes(currentStage);
    console.log('Domain restriction check:', { currentStage, isRestricted });
    return isRestricted;
};

export const isEmailDomainAllowed = (email) => {
    console.log('Checking email domain for:', email);
  
    if (!isDomainRestricted()) {
        console.log('Environment not restricted, allowing all domains');
        return true;
    }
  
    const domain = email.split('@')[1]?.toLowerCase();
    const isAllowed = ALLOWED_DOMAINS.includes(domain);
    console.log('Domain validation:', { email, domain, isAllowed, allowedDomains: ALLOWED_DOMAINS });
  
    return isAllowed;
};

export const getDomainErrorMessage = () => {
    console.log('Generating domain error message');
    return `Access restricted. Please contact your administrator for access to this application.`;
};

export const handleOAuthError = () => {
    // Check both current URL and any stored error
    const currentUrl = window.location.href;
    const urlWithParams = currentUrl.replace(/&/g, '&');
  
    // Also check if there are any hash parameters (sometimes OAuth uses hash)
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    const searchParams = new URLSearchParams(urlWithParams.split('?')[1] || '');
  
    const error = searchParams.get('error') || hashParams.get('error');
    const errorDescription = searchParams.get('error_description') || hashParams.get('error_description');
  
    // Always log what we're checking
    console.log('OAuth Error Check:', {
        currentUrl,
        error,
        errorDescription,
        hasSearchParams: urlWithParams.includes('?'),
        hasHashParams: window.location.hash.length > 0
    });
  
    // Check for any error indicators
    if (error || errorDescription || currentUrl.includes('error=') || currentUrl.includes('error_description=')) {
        console.log('ERROR DETECTED - Processing...');
    
        if (errorDescription?.toLowerCase().includes('registration not allowed') || 
        errorDescription?.toLowerCase().includes('not allowed for this environment')) {
            console.log('Backend domain restriction detected');
            alert(getDomainErrorMessage());
      
            // Clean URL after showing alert
            setTimeout(() => {
                window.history.replaceState({}, document.title, window.location.pathname);
            }, 100);
      
            return true;
        }
    }
  
    return false;
};

